import { TenantName } from './TenantName.js';

const PlatAndPlatCountryToTenant = {
  COM: {
    UN: TenantName.PACKLINK,
    ES: TenantName.PACKLINKES,
    IT: TenantName.PACKLINKIT
  },
  PRO: {
    UN: TenantName.PACKLINKPRO,
    ES: TenantName.PACKLINKPROES,
    FR: TenantName.PACKLINKPROFR,
    IT: TenantName.PACKLINKPROIT,
    DE: TenantName.PACKLINKPRODE
  },
  CORREOS: {
    ES: TenantName.CORREOSES
  },
  DPDCBE: {
    UN: TenantName.DPDCBEUN
  },
  DPDBBE: {
    UN: TenantName.DPDBBEUN
  },
  EBAY: {
    ES: TenantName.EBAYES,
    IT: TenantName.EBAYIT,
    FR: TenantName.EBAYFR,
    GB: TenantName.EBAYGB,
    IE: TenantName.EBAYIE,
    DE: TenantName.EBAYDE,
    AT: TenantName.EBAYAT,
    BE: TenantName.EBAYBE,
    NL: TenantName.EBAYNL
  },
  PAYPAL: {
    ES: TenantName.PAYPALES,
    FR: TenantName.PAYPALFR,
    IT: TenantName.PAYPALIT,
    PT: TenantName.PAYPALPT,
    DE: TenantName.PAYPALDE,
    BE: TenantName.PAYPALBE,
    IE: TenantName.PAYPALIE,
    AT: TenantName.PAYPALAT,
    NL: TenantName.PAYPALNL,
    GB: TenantName.PAYPALGB
  }
};

export { PlatAndPlatCountryToTenant };
//# sourceMappingURL=PlatAndPlatCountryToTenant.js.map
